<template>
  <div class="alert" :style="{ background: arry[index].colorType }">
    {{ arry[index].alarmType }}
  </div>
</template>
<script>
export default {
  name: "warning",
  props: {
    arry: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  mounted() {
    this.timer();
  },
  methods: {
    timer() {
      setInterval(() => {
        if (this.index < this.arry.length) {
          this.index++;
        } else {
          this.index = 0;
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.alert {
  margin-top: 4px;
  margin-left: 4px;
  width: 40px;
  height: 40px;
  padding: 5px;
  border-radius: 20px;
  font-size: 12px;
  color: #fff;
  overflow: hidden;
}
</style>